import { render } from "./PlusIcon.vue?vue&type=template&id=61e06070"
import script from "./PlusIcon.vue?vue&type=script&lang=js"
export * from "./PlusIcon.vue?vue&type=script&lang=js"
script.render = render

export default script